<div class="adblock-wrapper center">
  <div class="adblock-content-wrapper">
    <span class="adblock-close"></span>
    <div class="adblock-content">
      <div class="center">
        <div class="image-container">
          <div class="image">
            <h3>!</h3>
          </div>
        </div>
      </div>
      <div class="adblock-text pt-5">
        <h3 translate>Support Us by Disabling Your Ad Blocker!</h3>
        <p translate>
          Hey there! 😊 We work hard to keep this site running and provide you
          with the best experience possible. Our ads are minimal, non-intrusive,
          and carefully selected to ensure they don’t disrupt your browsing.
        </p>
      </div>
      <div class="adblock-button" (click)="documentService.reload()">
        <button class="btn" translate>I've disabled my ad blocker!</button>
      </div>
    </div>
  </div>
</div>
<!--
  This code below this line is not for modal popoup
  -->

<div class="example-page center"></div>
